/**
 * SDK 版本号：唯一真相源。
 * open.ts / launcher/bridge.ts / utils/embed-bridge.ts 均从此处导入。
 */
export const SDK_VERSION = '1.0.5'
